import { useEffect, useRef, useState } from 'react'
import { NumberParam, StringParam, useQueryParams } from 'use-query-params'

import { getConversationsFilters } from '../../../../api/conversations'
import useApiCall from '../../../../api/useApiCall'
import { ReactComponent as Settings } from '../../../../assets/icons/settings.svg'
import useOnClickOutside from '../../../../hooks/useOnClickOutside'
import { countFilters, DashArrayParam } from '../../../../utils/useQueryParams'

import ConversationsFiltersMenu from './ConversationsFiltersMenu/ConversationsFiltersMenu'
import ConversationsFiltersOptions from './ConversationsFiltersOptions/ConversationsFiltersOptions'

import { joinClassNames } from '../../../../utils/styles'
import styles from './conversations-filters.module.scss'

export enum ConversationsFiltersCategoriesEnum {
    'ENTITIES' = 'entities',
    'INTENTS' = 'intents',
    'ACTIONS' = 'actions',
    'OTHER' = 'other',
}

export enum ConversationsFiltersEnum {
    'ENTITIES' = 'entities',
    'INTENTS' = 'intents',
    'ACTIONS' = 'actions',
    'DATE_FROM' = 'date_from',
    'DATE_TO' = 'date_to',
    'CONVERSATION_LENGTH' = 'length',
}

function ConversationsFilters() {
    const [query] = useQueryParams({
        [ConversationsFiltersEnum.ENTITIES]: DashArrayParam,
        [ConversationsFiltersEnum.INTENTS]: DashArrayParam,
        [ConversationsFiltersEnum.ACTIONS]: DashArrayParam,
        [ConversationsFiltersEnum.DATE_FROM]: StringParam,
        [ConversationsFiltersEnum.DATE_TO]: StringParam,
        [ConversationsFiltersEnum.CONVERSATION_LENGTH]: NumberParam,
    })

    const [{ data: filtersOptions, loading }] = useApiCall(
        getConversationsFilters
    )

    const filtersRef = useRef<HTMLDivElement>(null)
    const [areFiltersOpen, setAreFiltersOpen] = useState(false)
    const [category, setCategory] = useState(
        ConversationsFiltersCategoriesEnum.ENTITIES
    )
    const [filtersCount, setFiltersCount] = useState<number>()

    useOnClickOutside(filtersRef, () => setAreFiltersOpen(false))

    useEffect(() => {
        setFiltersCount(countFilters(query))
    }, [query])

    if (loading || !filtersOptions) {
        return null
    }

    const {
        intent_names: intents,
        entity_labels: entities,
        action_names: actions,
    } = filtersOptions

    return (
        <div className={styles.conversationsFilters__wrapper}>
            <button
                className={joinClassNames(
                    styles.conversationsFilters__btn,
                    areFiltersOpen && styles.conversationsFilters__btnActive
                )}
                onClick={() =>
                    setAreFiltersOpen((areFiltersOpen) => !areFiltersOpen)
                }
            >
                {filtersCount ? (
                    <div className={styles.conversationsFilters__counter}>
                        {String(filtersCount)}
                    </div>
                ) : null}
                <Settings className={styles.conversationsFilters__btnIcon} />
            </button>
            {areFiltersOpen && (
                <div className={styles.conversationsFilters} ref={filtersRef}>
                    <ConversationsFiltersMenu
                        category={category}
                        setCategory={setCategory}
                    />
                    <ConversationsFiltersOptions
                        category={category}
                        filtersOptions={{ entities, intents, actions }}
                    />
                </div>
            )}
        </div>
    )
}

export default ConversationsFilters
